import React from "react";
import PropTypes from "prop-types";
import SortableTree from "react-sortable-tree";
import ProductRepository from "../../repository/ProductRepository";
import FormToastComponent from "../basics/FormToastComponent";

class ProductOverviewTreeComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            treeData: this.format(props.data)
        }
    }

    componentDidMount() {
        setTimeout(() => this.handleSortableTreeHeight(), 250);
    }

    update = (items) => ProductRepository.updateTree(items)
        .then(() => {
            FormToastComponent.successTrans("Products", "CMS.Product.overview.tree.updated")
            this.props.parent.updateData()
        })
        .catch(() => FormToastComponent.errorTrans("CMS.Product.overview.tree.failed"));

    // Group the products per category (when enabled), the order is saved per group
    format = (array) => {
        let groups = {};

        array.forEach(product => {
            let content = product.contents[this.props.index];
            let key = this.props.groupByCategory && product.category ? product.category : 0;

            if (!(key in groups)) {
                groups[key] = { title: key ? content?.category?.full_title : null, items: [] };
            }

            groups[key].items.push({
                title: content?.title,
                id: product.id,
                expanded: true
            });
        });

        return Object.values(groups).sort((a, b) => (a.title || '').localeCompare(b.title || ''));
    }

    render() {
        return this.state.treeData.map((group, i) => (
            <div key={i} className="mb-4">
                {group.title && <p className="font-weight-bold">{group.title}</p>}
                <div style={{ height: 500 }} className="sortable-wrapper">
                    <SortableTree
                        treeData={group.items}
                        onChange={items => {
                            let treeData = [...this.state.treeData];
                            treeData[i] = { ...group, items: items };
                            this.setState({ treeData });
                        }}
                        onMoveNode={({ treeData }) => this.update(treeData)}
                        maxDepth={1}
                    />
                </div>
            </div>
        ));
    }

    handleSortableTreeHeight = () => {
        [...document.querySelectorAll('.rst__tree')].forEach(el => {
            let height = el.querySelector('div[role="rowgroup"]').offsetHeight;
            el.closest('.sortable-wrapper').style.height = (height + 25) + 'px';
        });
    }
}

ProductOverviewTreeComponent.propTypes = {
    data: PropTypes.array.isRequired,
    index: PropTypes.number.isRequired,
    parent: PropTypes.object.isRequired,
    groupByCategory: PropTypes.bool
};
export default ProductOverviewTreeComponent;
